import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { UserSettings, GlobalState } from '@leverege/ui-redux';
import { Popup, Toast, Dialogs, Dialog, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Util from "../Util.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tf,
  tfArray,
  tIcon
} = I18N.ns('molten.views.userSettings.deleteUserProfileDialog');
function deleteUserProfileDialog(props) {
  const {
    show,
    onClose,
    onDelete,
    profile
  } = props;
  const onDel = evt => {
    onClose(evt);
    onDelete(evt);
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line max-len
    _jsx(Dialog.Question, {
      show: show,
      title: t('title'),
      okay: t('okay'),
      okayVariant: "primaryDestructive",
      onCancel: onClose,
      onOkay: onDel,
      children: /*#__PURE__*/_jsx(Text, {
        children: t('message', {
          displayName: profile.displayName
        })
      })
    })
  );
}
function ProfileRenderer({
  context,
  profiles,
  dispatch,
  canSystem,
  onClose: closeParent
}) {
  const {
    onClose,
    settingsPath,
    value,
    clientProps
  } = context;
  const actionCloseOnExec = clientProps?.actionCloseOnExec;
  useEffect(Util.getCanSystemEffect(dispatch, canSystem), []);
  if (!profiles?.length) {
    return null;
  }
  const showDeleteDialog = evt => {
    if (closeParent) closeParent();
    const onDelete = async () => {
      try {
        const scope = UserSettings.getProfileScope(GlobalState.get(), evt.data?.name, settingsPath);
        if (scope === 'user') {
          await UserSettings.resetUserProfile(evt.data?.name, settingsPath, value);
        }
        Toast.success([t('successToastTitle'), t('successToastMessage', {
          displayName: evt.data?.displayName
        })]);
      } catch (err) {
        Toast.error([t('errorToastTitle'), t('errorToastMessage1', {
          displayName: evt.data?.displayName
        }), t('errorToastMessage2', {
          error: err.message
        })]);
      }
      if (onClose && actionCloseOnExec) {
        onClose(evt);
      }
    };
    Dialogs.show({
      component: deleteUserProfileDialog,
      props: {
        onDelete,
        profile: evt.data
      }
    });
  };
  return profiles?.map(v => {
    const scope = UserSettings.getProfileScope(GlobalState.get(), v.name, settingsPath);
    return /*#__PURE__*/_jsx(Popup.Item, {
      disabled: scope !== 'user',
      onClick: showDeleteDialog,
      eventData: v,
      children: v.displayName
    }, v.name);
  });
}
export default {
  id: 'molten.userSetting.titleRight.delete.userProfiles',
  name: tf('name'),
  matches: {
    use: 'titleRight',
    client: 'UserSettingsEditor',
    managePersonas: true
  },
  handles: context => {
    return !context.simple;
  },
  layout: {
    group: ['reset', 'userProfiles'],
    groupIcons: [() => tIcon('icon', 'fa fa-repeat fa-fw'), null],
    groupNames: tfArray('groupNames'),
    sort: 'aaaa'
  },
  customComponent: connect((state, props) => ({
    profiles: Util.getProfiles(state, props, {
      getValues: true,
      getProfileFn: 'getProfile'
    }),
    canSystem: Util.getCanSystem(state, props)
  }))(ProfileRenderer)
};